import { ReactElement, useState } from 'react';
import { getUserProfile } from 'helpers/userProfile';
import { useFilterContext } from './contexts/FilterContext';
import { BetaContent, HeaderContainer, OverviewContainer } from './styles';
import { ClientSelectionInfo } from './components/ClientSelectionInfo';
import { OverviewContent } from './Content';
import { Filter } from './components/Filter';
import { Home } from './components/Home';

export function OverviewLayout(): ReactElement {
  const [profile] = useState(getUserProfile);
  const { client } = useFilterContext();

  const needSelectClient = profile.manageMultipleClients && !client;

  return (
    <OverviewContainer>
      <HeaderContainer>
        <Home />
        <Filter />
        <BetaContent>Beta</BetaContent>
      </HeaderContainer>
      <div id="filter-fields" />
      {needSelectClient ? (
        <ClientSelectionInfo />
      ) : (
        <OverviewContent />
      )}
    </OverviewContainer>
  );
}
